export const APP_BRAND_NAME = 'Beauty Treasures';
export const TOKEN_SESSION_KEY = 'BT-APP-TOKEN';
export const REFRESH_TOKEN_KEY = 'RE-TOKEN';
export const PAYLOAD_DATA_KEY = 'appBTpayload';

export const APP_START_YEAR = 2025;
export const APP_START_MONTH = 7;

export const DATE_SEPARATOR = '/';
export const TIME_SEPARATOR = ':';
export const SCROLL_RESTORE_PREFIX_KEY = 'scroll-pos-';

export const MAIN_MENU_SYSTEM_ADMIN = 'SYSTEM ADMIN';
export const MAIN_MENU_MANAGEMENT = 'MANAGEMENT';
export const MAIN_MENU_SHOP = 'SHOP';
export const MAIN_MENU_CATEGORY = 'CATEGORY';
export const MAIN_MENU_PRODUCT = 'PRODUCT';
export const MAIN_MENU_PURCHASE = 'PURCHASE';
export const MAIN_MENU_ORDER = 'ORDER';
export const MAIN_MENU_GENERAL_EXPEND = 'GENERAL EXPENSD';
export const MAIN_MENU_MONEY_ADJUSTMENT = 'MONEY ADJUSTMENT';
export const MAIN_MENU_INSTOCK_ADJUSTMENT = 'STOCK';
export const MAIN_MENU_PRINT_PDF = 'PRINT PDF';
export const MAIN_MENU_SETTING = 'SETTING';

export const SELECT_DEFAULT = '--select--';
export const SELECT_ALL_DEFAULT = '--All--';

export const ORDER_ID_PREFIX = 'BT';
export const ORDER_ID_LENGTH = 8;

export const TBL_DATA_SEPARATOR = '^';
export const SEARCH_TEXT_SEPARATOR = '$';

export const SERVER_ERROR_MESSAGE = 'Unable to connect to the server. Please check your connection.';

export const DELI_TYPE_DEFINE = {
    cashOnDelivery: {value: 5, text: "着払い"},
    prepaidDelivery: {value: 10, text: "発払い"},
    handToHand: {value: 20, text: "手渡し"}
}

export const DELI_TYPES = [
    DELI_TYPE_DEFINE.prepaidDelivery,
    DELI_TYPE_DEFINE.cashOnDelivery,
    DELI_TYPE_DEFINE.handToHand
]

export const ORDER_STATUS_DEFINE = {
    confirmed: {value: 10, text: "Confirmed"},
    paid: {value: 20, text: "Paid"},
    shipped: {value: 30, text: "Shipped"},
    finished: {value: 40, text: "Finished"},
    cancelled: {value: 50, text: "Cancelled"}
}

export const ORDER_STATUS = [
    ORDER_STATUS_DEFINE.confirmed,
    ORDER_STATUS_DEFINE.paid,
    ORDER_STATUS_DEFINE.shipped,
    ORDER_STATUS_DEFINE.finished,
    ORDER_STATUS_DEFINE.cancelled
]

export const ORDER_STATE_DEFINE = {
    pending: {value: 5, text: "Pending"},
    ...ORDER_STATUS_DEFINE
}
export const ORDER_STATE = [
    ORDER_STATE_DEFINE.pending,
    ...ORDER_STATUS
];

export const PAYMENT_BANKS = [
    "Cash",
    "ゆうちょ",
    "MUFG",
    "SMBC",
    "Pay Pay",
    "Rakuten",
    "Others"
]